import React from 'react';
import { Badge } from '@fluentui/react-components';
import { ExceptionCase, CaseStatus, Severity } from '../../data/mockExceptionData';
import styles from './ExceptionWorkspace.module.css';

const statusAppearance: Record<CaseStatus, 'filled' | 'outline' | 'tint'> = {
  detected: 'outline',
  investigating: 'tint',
  waiting_on_owner: 'tint',
  approval_needed: 'filled',
  action_taken: 'tint',
  resolved: 'filled',
  escalated: 'filled',
  closed: 'outline',
  written_off: 'outline',
};

const statusColor: Record<CaseStatus, 'informative' | 'warning' | 'success' | 'danger' | 'important' | 'subtle' | 'brand'> = {
  detected: 'informative',
  investigating: 'brand',
  waiting_on_owner: 'warning',
  approval_needed: 'important',
  action_taken: 'brand',
  resolved: 'success',
  escalated: 'danger',
  closed: 'subtle',
  written_off: 'subtle',
};

const severityColor: Record<Severity, 'danger' | 'warning' | 'important' | 'subtle'> = {
  critical: 'danger',
  high: 'important',
  medium: 'warning',
  low: 'subtle',
};

interface Props {
  cases: ExceptionCase[];
  selectedCaseId: string | null;
  onSelectCase: (caseId: string) => void;
}

const ExceptionCaseQueue: React.FC<Props> = ({ cases, selectedCaseId, onSelectCase }) => (
  <div className={styles.queueSection}>
    <div className={styles.queueSectionTitle}>Exception Cases ({cases.length})</div>
    {cases.map(c => (
      <div
        key={c.case_id}
        className={`${styles.caseItem} ${selectedCaseId === c.case_id ? styles.caseItemSelected : ''}`}
        onClick={() => onSelectCase(c.case_id)}
      >
        <div className={styles.caseTitle}>{c.title}</div>
        <div className={styles.caseMeta}>
          <Badge size="small" appearance={statusAppearance[c.status]} color={statusColor[c.status]}>
            {c.status.replace(/_/g, ' ')}
          </Badge>
          <Badge size="small" appearance="outline" color={severityColor[c.severity]}>
            {c.severity}
          </Badge>
          <span style={{ fontSize: 11, color: '#8a8886' }}>
            {c.workflow_type.replace(/_/g, ' ')}
          </span>
        </div>
      </div>
    ))}
    {cases.length === 0 && <div style={{ color: '#8a8886', fontSize: 13 }}>No cases match filters</div>}
  </div>
);

export default ExceptionCaseQueue;
